import http from "./http-common";
import ArticleModel from "../models/article";
import qs from "qs";

// Navbar APIs
// eslint-disable-next-line
export default new (class ArticleService {
  // Get all members
  async getMainpageArticle() {
    return await http
      .get(
        "/articles?sort%5b0%5d=publishedAt:desc&pLevel&pagination%5bpage%5d=1&pagination%5bpageSize%5d=2"
      )
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((article) => ArticleModel.get(article))
        );

        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Get all
  async getArticle({ page = 1, pageSize = 5, sort = "desc" }) {
    const query = qs.stringify(
      {
        sort: [`publishedAt:${sort}`],
        pLevel: 5,
        pagination: {
          page: page,
          pageSize: pageSize,
        },
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/articles?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((article) => ArticleModel.get(article))
        );

        const meta = response.data.meta;

        return [data, meta];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Get by name
  async getArticlesBySlug(slug, status = 'published') {
    return await http
      // ให้ Strapi กรองด้วย slug — ดึงมาทั้งหมดแล้วค่อยหาจะได้แค่ 25 รายการแรก
      .get(`/articles?pLevel&status=${status}&filters[Slug][$eq]=${encodeURIComponent(slug)}`)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((article) => ArticleModel.get(article))
        );

        return data[0];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getArticleByTag({ sort = "desc", tag = "" }) {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              tag: {
                tag: {
                  $eq: tag,
                },
              },
            },
          ],
        },
        sort: [`publishedAt:${sort}`],
        pLevel: 5,
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/articles?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((article) => ArticleModel.get(article))
        );

        return [data];
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();
